<template>
    <div v-if="showBanking" id="banking">
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__1">Banking</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__2">Banking - General Banking Details</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Minimum Deposit ($):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="minimum_deposit" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Free Checking:
            </v-col>
            <v-col cols="auto" class="text-left no-left no-bottom no-top">
                <v-checkbox label="Yes" v-model="free_checking" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Checking APR (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="checking_apr" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Checking APY (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="checking_apy" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Saving APR (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="saving_apr" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Saving APY (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="saving_apy" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Money Market APR (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="money_market_apr" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Money Market APY (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="money_market_apy" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                C/D APR (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="cd_apr" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                C/D APY (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="cd_apy" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__2">Banking - Debit Card Details</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Debit Card Mentioned:
            </v-col>
            <v-col cols="auto" class="text-left no-left no-bottom no-top">
                <v-checkbox label="Yes" v-model="debit_card_mentioned" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Card Type:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-select outlined dense :items="all_card_types" v-model="card_type" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__2">Banking - Reward Program Details</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Reward Program:
            </v-col>
            <v-col cols="auto" class="text-left no-left no-bottom no-top">
                <v-checkbox label="Yes" v-model="reward_program" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding" v-if="toggle_program_emphasis">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Reward Program Emphasis:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-select :items="all_reward_program_emphasis" dense outlined multiple chips
                    v-model="reward_program_emphasis" />
            </v-col>
        </v-row>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'
export default {
    name: 'Banking',
    props: [
        "showBanking"
    ],
    data: () => ({
        items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
        //emphasis_options: [{text:'Select One',value:''},{text:'Miles',value:1},{text:'Points',value:2},{text:'Cash-back',value:3}],
        toggle_program_emphasis: false

    }),
    watch: {
        reward_program: function (o) {
            if (o) {
                this.toggle_program_emphasis = true
            } else {
                this.toggle_program_emphasis = false
                this.$store.dispatch('ProductData/setBankingRewardProgramEmphasis', '')
            }
        }
    },
    computed: {
        ...mapGetters({
            sector: 'ProductData/getSector',
            all_card_types: 'ProductData/getAllCardTypes',
            all_card_types_multiple: 'ProductData/getAllCardTypesMultiple',
            all_reward_program_emphasis: 'ProductData/getAllRewardTypes',
        }),
        reward_program_emphasis: {
            get: function () {
                return this.$store.getters['ProductData/getBankingRewardProgramEmphasis']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingRewardProgramEmphasis', o)
            },
        },
        reward_program: {
            get: function () {
                return this.$store.getters['ProductData/getBankingRewardProgram']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingRewardProgram', o)
            },
        },
        card_type: {
            get: function () {
                return this.$store.getters['ProductData/getBankingCardType']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingCardType', o)
            },
        },
        debit_card_mentioned: {
            get: function () {
                return this.$store.getters['ProductData/getBankingDebitCardMentioned']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingDebitCardMentioned', o)
            },
        },
        cd_apy: {
            get: function () {
                return this.$store.getters['ProductData/getBankingCdApy']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingCdApy', o)
            },
        },
        cd_apr: {
            get: function () {
                return this.$store.getters['ProductData/getBankingCdApr']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingCdApr', o)
            },
        },
        money_market_apy: {
            get: function () {
                return this.$store.getters['ProductData/getBankingMoneyMarketApy']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingMoneyMarketApy', o)
            },
        },
        money_market_apr: {
            get: function () {
                return this.$store.getters['ProductData/getBankingMoneyMarketApr']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingMoneyMarketApr', o)
            },
        },
        saving_apy: {
            get: function () {
                return this.$store.getters['ProductData/getBankingSavingApy']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingSavingApy', o)
            },
        },
        saving_apr: {
            get: function () {
                return this.$store.getters['ProductData/getBankingSavingApr']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingSavingApr', o)
            },
        },
        checking_apy: {
            get: function () {
                return this.$store.getters['ProductData/getBankingCheckingApy']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingCheckingApy', o)
            },
        },
        checking_apr: {
            get: function () {
                return this.$store.getters['ProductData/getBankingCheckingApr']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingCheckingApr', o)
            },
        },
        free_checking: {
            get: function () {
                return this.$store.getters['ProductData/getBankingFreeChecking']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingFreeChecking', o)
            },
        },
        minimum_deposit: {
            get: function () {
                return this.$store.getters['ProductData/getBankingMinimumDeposit']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setBankingMinimumDeposit', o)
            },
        },
    },
}
</script>

<style lang="sass" scoped>
@import './../../assets/sass/product/banking'
</style>